import React from "react";
import "./index.css";

const Button = ({ children, onClick, outlined = false, color, className }) => {
  const handleClick = (e) => {
    onClick && onClick(e);
  };

  return (
    <button
      className={`Button${outlined ? " Button--outlined" : ""}${
        color ? " Button--" + color : ""
      }${className ? " " + className : ""}`}
      onClick={(e) => handleClick(e)}
    >
      {children}
    </button>
  );
};

export default Button;
